import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance'; // ✅ axios avec token automatiquement injecté
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import ConfirmDialog from './ConfirmDialog';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  CircularProgress
} from '@mui/material';
import '../css/ManageCompanies.css';

const ManageCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);

  const fetchCompanies = async () => {
    try {
      const response = await axios.get('/societes');
      setCompanies(response.data);
    } catch (err) {
      setError('Erreur lors du chargement des entreprises');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleDelete = (id) => {
    setCompanyToDelete(id);
    setShowConfirmDialog(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`/societes/${companyToDelete}`);
      setCompanies(companies.filter(c => c._id !== companyToDelete));
      setShowConfirmDialog(false);
    } catch (err) {
      setError("Erreur lors de la suppression de l'entreprise");
    }
  };

  const handleCloseDialog = () => {
    setShowConfirmDialog(false);
    setCompanyToDelete(null);
  };

  return (
    <Box className="manage-companies-container">
      <Sidebar />
      <Box className="main-content">
        <Paper className="company-paper" elevation={3}>
          <Typography variant="h5" gutterBottom>Gérer les entreprises</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {loading ? (
            <Box className="loading-box">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box sx={{ mb: 2 }}>
                <Link to="/add-company">
                  <Button variant="contained" className="add-button">Ajouter une entreprise</Button>
                </Link>
              </Box>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SIRET</TableCell>
                      <TableCell>Nom</TableCell>
                      <TableCell>Nombre d'utilisateurs</TableCell>
                      <TableCell>Emails des utilisateurs</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {companies.map((company) => (
                      <TableRow key={company._id}>
                        <TableCell>{company.siret}</TableCell>
                        <TableCell>{company.nom}</TableCell>
                        <TableCell>{company.users?.length || 0}</TableCell>
                        <TableCell>
                          {company.users?.length
                            ? company.users
                                .filter(u => u && u.emailAddress)
                                .map(u => u.emailAddress)
                                .join(', ')
                            : 'Aucun utilisateur associé'}
                        </TableCell>
                        <TableCell>
                          <Link to={`/edit-company/${company._id}`}>
                            <Button size="small" variant="outlined" color="warning" sx={{ mr: 1 }}>
                              Éditer
                            </Button>
                          </Link>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => handleDelete(company._id)}
                          >
                            Supprimer
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Paper>
      </Box>

      <ConfirmDialog
        show={showConfirmDialog}
        onHide={handleCloseDialog}
        onConfirm={confirmDelete}
        title="Confirmation de la suppression"
        message="Êtes-vous sûr de vouloir supprimer cette entreprise ?"
      />
    </Box>
  );
};

export default ManageCompanies;
